module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Cooking-book-b7cbfcef69d66d4382f438ca89c908b9.svg";